import { useEffect, useState } from 'react';

/** The Ministry's HRIS: public vacancy list and the e-recruitment portal where candidates apply. */
export const HRIS_JOBS = 'https://hris.mof.gov.tl/api/v1/jobs';
export const HRIS_SIGN_IN = 'https://hris.mof.gov.tl/e-recruitment/sign_in';

/**
 * A vacancy still taking applications. HRIS deadlines are often a date without a time, so the
 * whole closing day counts as open. A vacancy without a deadline is open while HRIS lists it.
 */
export function isOpenJob(job, now = Date.now()) {
    if (!job) return false;
    if (!job.deadline) return true;
    const end = new Date(job.deadline);
    if (Number.isNaN(end.getTime())) return true;
    if (/^\d{4}-\d{2}-\d{2}$/.test(String(job.deadline))) end.setHours(23, 59, 59, 999);
    return end.getTime() >= now;
}

/** Number of open vacancies, or null while loading or if HRIS cannot be reached. */
export async function countOpenJobs(fetchImpl = fetch, now = Date.now()) {
    const response = await fetchImpl(HRIS_JOBS, { credentials: 'omit' });
    if (!response.ok) return null;
    const jobs = await response.json();
    return Array.isArray(jobs) ? jobs.filter((job) => isOpenJob(job, now)).length : null;
}

export function useOpenJobCount() {
    const [count, setCount] = useState(null);
    useEffect(() => {
        let active = true;
        countOpenJobs()
            .then((value) => active && setCount(value))
            .catch(() => active && setCount(null));
        return () => {
            active = false;
        };
    }, []);
    return count;
}
